export default __webpack_public_path__ + "static/media/CormorantGaramond-Regular.4114a151.ttf";